__webpack_require__.p = "https://www.cideteq.mx/proveedores/";